"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
function UploadThumbDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/upload-thumb.html',
        controller: /** @class */ (function (_super) {
            __extends(UploadThumbController, _super);
            function UploadThumbController($scope, book, uploads) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                _this.uploads = uploads;
                return _this;
            }
            UploadThumbController.prototype.getThumbnail = function () {
                return this.uploads.getThumbnail("" + this.value);
            };
            return UploadThumbController;
        }(form_1.FormOptionController)),
        controllerAs: 'uploadThumbCtrl'
    };
}
exports.UploadThumbDirective = UploadThumbDirective;
